module.exports = __webpack_public_path__ + "static/media/2.00466d55.png";